export default "__VITE_ASSET__CYmFryLq__"